import { render, staticRenderFns } from "./BloqueBlogNew.vue?vue&type=template&id=07bc3308&scoped=true"
import script from "./BloqueBlogNew.vue?vue&type=script&lang=js"
export * from "./BloqueBlogNew.vue?vue&type=script&lang=js"
import style0 from "./BloqueBlogNew.vue?vue&type=style&index=0&id=07bc3308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bc3308",
  null
  
)

export default component.exports